import React, { useState, useEffect, useMemo } from "react";
import { Button, useTheme, Box, IconButton, Stack, Dialog, DialogContent, DialogTitle, CircularProgress, Tooltip, Typography, Select, MenuItem, Checkbox } from "@mui/material";
import Chip from '@mui/material/Chip';
import { tokens } from "../../assets/theme";
import { useQuery } from "@tanstack/react-query";
import { useLocalStorage } from "../../hooks/useLocalStorage";
//Components
import AxionControls from "../../components/controls/AxionControls";
import { pushErrorMessage } from "../../utils/notifications";
import AxionConfirmation from '../../components/controls/AxionConfirmation';
import Controls from "../../components/controls/Contols";
//Hooks
import { getCategories, postCategory, patchCategory, deleteCategory } from "../../fetchers/incidentCategory";
import { getDepartments } from "../../fetchers/departments";
import { postCategoryValues } from "../../fetchers/incidentCategoryValues";
//Icons
import SaveIcon from '@mui/icons-material/Save';
import DeleteOutlinedIcon from '@mui/icons-material/DeleteOutlined';
import AddCircleOutlinedIcon from '@mui/icons-material/AddCircleOutlined';
import EditOutlinedIcon from '@mui/icons-material/EditOutlined';
import AddIcon from "@mui/icons-material/Add";
//Language
import messages from "./messages";
import { FormattedMessage, useIntl } from "react-intl";
import { getTopLevelCategories } from "../../fetchers/incidentTopLevelCategory";
import { post } from "jquery";

export default function EditCategories(props) {
    console.log("EditCategories", props);

    const { formatMessage } = useIntl();
    const theme = useTheme();
    const colors = tokens(theme.palette.mode);
    const [companyKey, setCompanyKey] = useLocalStorage("companyKey", 1);
    const [newCategory, setNewCategory] = useState({ id: null, name: "", companyId: companyKey, sortorder: 0, departments: [] });
    const [showAddCategory, setShowAddCategory] = useState(true);
    const [openDialog, toggleOpenDialog] = useState(false);

    const [department, setDepartment] = useState(0);
    const [filteredCategories, setFilteredCategories] = useState([]);
    const [openValueDialog, toggleOpenValueDialog] = useState(false);
    const [confirmationTitle, setConfirmationTitle] = useState("");
    const [confirmationMessage, setConfirmationMessage] = useState("");
    const [categoryId, setCategoryId] = useState(null);
    const [openConfirmationCategory, setOpenConfirmationCategory] = useState(false);
    const [newValue, setNewValue] = useState(
        [{ id: null, taskIncidentCategoryId: null, name: "", color: "#D34D47", severityLevel: 1, active: true, departmentId: 0 },
        { id: null, taskIncidentCategoryId: null, name: "", color: "#ff9800", severityLevel: 2, active: true, departmentId: 0 },
        { id: null, taskIncidentCategoryId: null, name: "", color: "#F7E200", severityLevel: 3, active: true, departmentId: 0 },
        { id: null, taskIncidentCategoryId: null, name: "", color: "#43B328", severityLevel: 4, active: true, departmentId: 0 },
        { id: null, taskIncidentCategoryId: null, name: "", color: "#6870fa", severityLevel: 5, active: true, departmentId: 0 }]
    );


    const categoriesQuery = useQuery(
        ["categories", companyKey],
        () => getCategories(companyKey),
        {}
    );

    const topLevelQuery = useQuery(
        ["Categories", companyKey],
        () => getTopLevelCategories(companyKey),
        {}
    );

    const departmentsQuery = useQuery(
        ["Departments", companyKey],
        () => getDepartments(companyKey),
        {}
    );


    useEffect(() => {
        if (categoriesQuery.data) {
            setFilteredCategories(categoriesQuery.data);
        }
    }, [categoriesQuery.data]);

    const handleCloseDialog = () => {
        setNewCategory({ id: null, name: "", companyId: companyKey, sortorder: 0, departments: [] });
        toggleOpenDialog(false);
    };

    const handleCloseValueDialog = () => {
        setNewValue(
            [{ id: null, taskIncidentCategoryId: null, name: "", color: "#D34D47", severityLevel: 1, active: true, departmentId: 0 },
            { id: null, taskIncidentCategoryId: null, name: "", color: "#ff9800", severityLevel: 2, active: true, departmentId: 0 },
            { id: null, taskIncidentCategoryId: null, name: "", color: "#F7E200", severityLevel: 3, active: true, departmentId: 0 },
            { id: null, taskIncidentCategoryId: null, name: "", color: "#43B328", severityLevel: 4, active: true, departmentId: 0 },
            { id: null, taskIncidentCategoryId: null, name: "", color: "#6870fa", severityLevel: 5, active: true, departmentId: 0 }]
        );
        toggleOpenValueDialog(false);
    };

    const handleAddCategory = () => {

        //console.log("new/edit category", newCategory);

        if (newCategory.id !== null) {

            //console.log("patchCategory", newCategory);
            patchCategory(newCategory).then(() => {
                categoriesQuery.refetch();
                handleCloseDialog();
            }).catch((error) => {
                console.log(error);
                //setShowBackdrop(false);
                pushErrorMessage(formatMessage(messages.could_not_update_category));
            });
        } else {

            postCategory(newCategory).then(() => {
                categoriesQuery.refetch();
                handleCloseDialog();
            }).catch((error) => {
                console.log(error);
                //setShowBackdrop(false);
                pushErrorMessage(formatMessage(messages.could_not_create_category));
            });
        }
    }

    const handleAddValue = () => {

        console.log("AddnewValue", newValue);
        postCategoryValues(newValue).then(() => {
            categoriesQuery.refetch();
            handleCloseValueDialog();
        }).catch((error) => {
            console.log(error);
            //setShowBackdrop(false);
            pushErrorMessage(formatMessage(messages.could_not_create_category));
        }
        );

    }

    const handlePrepareAddCategory = () => {

        toggleOpenDialog(true);
        setShowAddCategory(true);
        //setShowAddValue(false);
    }

    const handleNameChange = (event) => {
        let category = { ...newCategory };
        category.name = event.target.value;
        setNewCategory(category);
    }

    function getSeverityLevelColor(level) {
        let color = "#D34D47";
        switch (level) {
            case 1:
                color = "#D34D47";
                break;
            case 2:
                color = "#ff9800";
                break;
            case 3:
                color = "#F7E200";
                break;
            case 4:
                color = "#43B328";
                break;
            case 5:
                color = "#6870fa";
                break;
            default:
                break;
        }
        return color;
    }

    const handleValueChange = (event, level) => {
        let value = [...newValue];
        let val = value.find(v => v.severityLevel === level);
        //console.log("val", val);
        if (val !== null && val !== undefined) {
            val.name = event.target.value;
        } else {
            let categoryid = value[0]?.taskIncidentCategoryId;
            val = { id: null, taskIncidentCategoryId: categoryid, name: event.target.value, color: getSeverityLevelColor(level), severityLevel: level, active: true, departmentId: 0 };
            value.push(val);
        }
        setNewValue(value);
    }

    const handleTopLevelChange = (event) => {
        let category = { ...newCategory };
        category.taskIncidentCategoryTopLevelId = event.target.value;
        setNewCategory(category);
    }

    const handleDepartmentSelectChange = (event) => {
        let category = { ...newCategory };
        let dep = departmentsQuery.data.find(d => d.id === event.target.value);
        category.departments = [dep];
        setNewCategory(category);
    }

    const handleDepartmentChange = (event) => {
        let category = { ...newCategory };

        console.log("handleDepartmentChange", category);

        if (event.target.checked) {
            let dept = departmentsQuery.data.find(d => d.id.toString() === event.target.id);
            console.log("dept", dept, category.departments);
            if (dept !== null) {
                if (category.departments === null || category.departments === undefined) {
                    category.departments = [];
                }
                category.departments.push(dept);
            }
        } else {
            category.departments = category.departments.filter(d => d.id.toString() !== event.target.id);
        }

        setNewCategory(category);
    }

    const handleEditCategoryClick = (id) => {
        let dim = categoriesQuery.data?.filter(d => d.id === id);

        let category = { ...newCategory };
        category.id = id;
        category.name = dim[0].name;
        category.departments = [dim[0].department];

        setNewCategory(category);
        toggleOpenDialog(true);
    }


    const handleDeleteCategory = (id) => {
        setCategoryId(id);
        setConfirmationTitle(formatMessage(messages.delete_category));
        setConfirmationMessage(formatMessage(messages.sure_delete_category));
        setOpenConfirmationCategory(true);
    }

    const doDeleteCategory = () => {
        setConfirmationTitle("");
        setConfirmationMessage("");
        setOpenConfirmationCategory(false);

        console.log("handleDeleteCategoryClick", categoryId);
        deleteCategory(categoryId).then(() => {
            console.log("handleDeleteCategoryClick yep!", categoryId);
            setCategoryId(null);
            categoriesQuery.refetch();
        }).catch((error) => {
            console.log(error);
            console.log("handleDeleteCategoryClick nope!", categoryId);
            setCategoryId(null);
            pushErrorMessage(formatMessage(messages.could_not_delete_category));
        });
    }

    const cancelDeleteCategory = () => {
        setCategoryId(null);
        setConfirmationTitle("");
        setConfirmationMessage("");
        setOpenConfirmationCategory(false);
    }


    const handleDeleteCategoryClick = (id) => {
        console.log("handleDeleteCategoryClick", id);
        deleteCategory(id).then(() => {
            console.log("handleDeleteCategoryClick yep!", id);
            categoriesQuery.refetch();
        }).catch((error) => {
            console.log(error);
            console.log("handleDeleteCategoryClick nope!", id);
            //setShowBackdrop(false);
            pushErrorMessage(formatMessage(messages.could_not_delete_category));
        });
    }

    const handleEditValuesClick = (id) => {

        let dim = categoriesQuery.data?.find(d => d.id === id);

        console.log("dim", dim);
        if (dim.values === null || dim.values.length === 0) {
            let value = [...newValue];
            value.forEach(v => {
                v.taskIncidentCategoryId = id;
            }
            );
            setNewValue(value);
        } else {
            setNewValue(dim.values);
        }

        toggleOpenValueDialog(true);
    }

    const setDepartmentAndReload = (department) => {
        setDepartment(department);
        let filteredCategories = [];
        if (department === 0) {
            filteredCategories = categoriesQuery.data;
        } else {
            filteredCategories = categoriesQuery.data.filter(x => x.departmentId === department);
        }
        setFilteredCategories(filteredCategories);
        //categoriesQuery.refetch();
    }

    function getTopLevelText(id) {

        // console.log("getTopLevelText", id);
        let text = "";
        if (id === null) {
            //text = formatMessage(messages.noneSelected);
            text = "";
        } else {
            let cat = topLevelQuery.data.find(x => x.id === id);

            console.log("cat", cat);

            let groupName = "Huh!";//cat.taskIncidentCategoryTopLevelGroupId === 1 ? "Operations" : "Management";

            text = cat?.name + ' (' + groupName + ')';
        }
        return text;
    }

    let spinner = <div
        style={{
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            height: "100vh",
        }}
    >
        <CircularProgress color="secondary" />
    </div>

    if (categoriesQuery.isLoading) {
        return (spinner);
    }
    if (topLevelQuery.isLoading) {
        return (spinner);
    }
    if (departmentsQuery.isLoading) {
        return (spinner);
    }

    //console.log("categoriesQuery", categoriesQuery.data)
    //console.log("newCategory", newCategory);
    //console.log("departments:", departmentsQuery.data);
    //console.log("newValue", newValue);

    
    return (
        <>
            <Box padding="30px"> </Box>
            <Box width="70%">
                <Stack direction="row" width="100%" overflow="hidden" spacing="1px" marginLeft="15px">
                    <Select value={department} onChange={(e) => setDepartmentAndReload(e.target.value)} sx={{ width: "200px" }}>
                        <MenuItem key={0} value={0} ><FormattedMessage {...messages.all_departments} /></MenuItem>
                        {departmentsQuery.data?.sort((a, b) => (a.name > b.name) ? 1 : -1)?.map((d) => (
                            <MenuItem key={d.id} value={d.id} >{d.name}</MenuItem>
                        ))}
                    </Select>
                    <Box width="100%" justifyContent="flex-end" alignItems="center" display="flex" marginTop="10px" marginBottom="20px" marginLeft="15px">
                        <Controls.Button
                            onClick={handlePrepareAddCategory}
                            text={formatMessage(messages.add_category)}
                            startIcon={<AddCircleOutlinedIcon />}
                            sx={{
                                "&:hover": {
                                    backgroundColor: colors.dashbordGreen[700],
                                },
                                backgroundColor: colors.dashbordGreen[500],
                                color: "#000000",
                            }}
                        />
                    </Box>

                </Stack>

                <Stack direction="column" width="100%" overflow="hidden" backgroundColor={colors.primary[300]} marginTop="5px" color="#ffffff" spacing="1px" marginLeft="15px">
                    <Stack backgroundColor={colors.primary[400]} direction="row" width="100%" marginLeft="10px">
                        <Box width="20%" alignItems="center" justifyContent="flex-start" display="flex" padding="10px"><FormattedMessage {...messages.categories} /></Box>
                        <Box width="25%" alignItems="center" justifyContent="flex-start" display="flex" padding="10px"><FormattedMessage {...messages.departments} /></Box>
                        <Box width="40%" alignItems="center" justifyContent="flex-start" display="flex" padding="10px"><FormattedMessage {...messages.values} /></Box>
                        <Box width="5%" alignItems="center" justifyContent="flex-end" display="flex" padding="10px"><FormattedMessage {...messages.edit} /></Box>
                        <Box width="10%" alignItems="center" justifyContent="flex-end" display="flex" padding="10px"><FormattedMessage {...messages.delete} /></Box>
                    </Stack>

                    {filteredCategories.sort((a, b) => (a.department?.name < b.department?.name) ? 1 : -1).sort((a, b) => (a.name > b.name) ? 1 : -1).map((a) => {
                        return (
                            <>
                                <Stack direction="row" width="100%" backgroundColor={colors.primary[500]}>

                                    <Box width="20%" alignItems="center" justifyContent="flex-start" display="flex" marginLeft="10px" onClick={() => handleEditCategoryClick(a.id)}>{a.name}</Box>
                                    <Box width="25%" alignItems="center" justifyContent="flex-start" display="flex" marginLeft="20px">
                                        {a.department?.name}
                                    </Box>
                                    <Stack direction="row" spacing="10px" width="40%" display="flex" marginLeft="10px" alignItems="center" onClick={() => handleEditValuesClick(a.id)} sx={{ cursor: 'pointer' }}>
                                        {(a.vales === null || a.values?.length === 0) ? <Box><AddCircleOutlinedIcon></AddCircleOutlinedIcon></Box> : <Box><EditOutlinedIcon></EditOutlinedIcon></Box>}

                                        {a.values.sort((a, b) => (a.severityLevel > b.severityLevel) ? 1 : -1).map((v) => {
                                            return (
                                                <Box sx={{ whiteSpace: 'nowrap' }} display="flex"><Box width="10px" height="10px" marginTop="4px" marginRight="3px" backgroundColor={v.color}></Box><Box> {v.name}</Box></Box>
                                            )
                                        }
                                        )}

                                    </Stack>

                                    <Box width="5%" justifyContent="flex-end" alignItems="center" display="flex" paddingRight="10px">
                                        <Tooltip title={<Typography fontSize="12px"><FormattedMessage {...messages.edit_category} /> {a.name}</Typography>}>
                                            <IconButton onClick={() => { handleEditCategoryClick(a.id) }}><EditOutlinedIcon /></IconButton>
                                        </Tooltip>
                                    </Box>
                                    <Box width="10%" justifyContent="flex-end" alignItems="center" display="flex" paddingRight="10px">
                                        <Tooltip title={<Typography fontSize="12px"><FormattedMessage {...messages.edit_category} /> {a.name}</Typography>}>
                                            <IconButton onClick={() => { handleDeleteCategory(a.id) }}><DeleteOutlinedIcon /></IconButton>
                                        </Tooltip>
                                    </Box>
                                </Stack>
                            </>
                        )
                    })}
                    <Box padding="0px"> </Box>
                </Stack>
            </Box>

            <Dialog open={openDialog} onClose={handleCloseDialog} m={0} width="400px">
                <Box m={0} sx={{ backgroundColor: colors.primary[400], borderRadius: "4px" }} width="400px" >
                    {/* <form onSubmit={handleAddDimension}> */}
                    <DialogTitle>{(newCategory.id === null) ? <FormattedMessage {...messages.add_a_new_category} /> : <FormattedMessage {...messages.update_a_category} />}</DialogTitle>
                    <DialogContent>

                        <Stack direction="column" width="100%" overflow="hidden" spacing="0px" >
                            <Box><AxionControls.AxionTextBox
                                label={<FormattedMessage {...messages.name} />}
                                value={newCategory.name}
                                autoComplete="new-password"
                                inputProps={{ autoComplete: 'new-password' }}
                                onChange={(event) =>
                                    handleNameChange(event)
                                }
                            /></Box>

                            {newCategory.id !== null &&
                                <>
                                    <Box paddingTop="20px"><FormattedMessage {...messages.select_department} /></Box>
                                    <Box width="100%">
                                        <Select
                                            sx={{ width: '100%' }}
                                            labelId="toplevel-label"
                                            id="toplevel-select"
                                            value={newCategory.departments[0]?.id || 0}
                                            //sx={{ width: '200px' }}
                                            label={"Top level"} //<FormattedMessage {...messages.type} />
                                            onChange={handleDepartmentSelectChange}
                                        >
                                            <MenuItem key={0} value={0} ><FormattedMessage {...messages.noneSelected} /></MenuItem>
                                            {departmentsQuery?.data?.sort((a, b) => (a.sortorder > b.sortorder) ? 1 : -1).map((t) => (
                                                <MenuItem key={t.id} value={t.id} >
                                                    {t.name}
                                                </MenuItem>
                                            ))}
                                        </Select>
                                    </Box>
                                </>}

                            {newCategory.id === null &&
                                <>
                                    <Box paddingTop="20px">Skapa för följande avdelningar</Box>
                                    <Stack direction="column" width="100%" overflow="hidden" marginTop="15px" display="flex" justifyContent="flex-start" spacing="-5px">
                                        {departmentsQuery?.data.map((d) => {
                                            return (
                                                <Stack direction="row" width="100%" display="flex" justifyContent="flex-start" alignItems="center">
                                                    <Checkbox
                                                        checked={newCategory.departments?.find(dept => dept.id === d.id)}
                                                        onChange={handleDepartmentChange}
                                                        inputProps={{ 'aria-label': 'controlled' }}
                                                        id={d.id}
                                                        sx={{
                                                            //color: colors.dashbordGreen[500],
                                                            '&.Mui-checked': {
                                                                color: colors.dashbordGreen[500],
                                                            },
                                                        }}
                                                    />
                                                    <Box>{d.name}</Box>
                                                </Stack>
                                            )
                                        })}
                                    </Stack>
                                </>}
                        </Stack>

                        <Stack direction="row" width="100%" overflow="hidden" marginTop="15px" display="flex" justifyContent="flex-end">
                            <Controls.Button
                                text={<FormattedMessage {...messages.btn_close} />}
                                onClick={handleCloseDialog}
                                // startIcon={<SaveIcon />}
                                sx={{
                                    "&:hover": {
                                        backgroundColor: "#535560",
                                    },
                                    backgroundColor: colors.primary[300],
                                    color: "#000000",

                                }}
                            />
                            <Controls.Button
                                marginLeft="10px"
                                text={(newCategory.id === null) ? formatMessage(messages.update_category) : formatMessage(messages.update_category)}
                                onClick={handleAddCategory}
                                startIcon={<SaveIcon />}
                                sx={{
                                    "&:hover": {
                                        backgroundColor: colors.dashbordGreen[700],
                                    },
                                    backgroundColor: colors.dashbordGreen[500],
                                    color: "#000000",
                                    marginLeft: "10px"
                                }}
                            />
                        </Stack>
                    </DialogContent>
                </Box>
            </Dialog>


            <Dialog open={openValueDialog} onClose={handleCloseValueDialog} m={0} width="400px">
                <Box m={0} sx={{ backgroundColor: colors.primary[400], borderRadius: "4px" }} width="400px" >
                    <DialogTitle><FormattedMessage {...messages.values_title} /></DialogTitle>
                    <DialogContent>

                        <Stack direction="column" width="100%" overflow="hidden" spacing="10px" >
                            <Box>
                                <Box sx={{ whiteSpace: 'nowrap' }} display="flex"><Box width="10px" height="10px" marginTop="4px" marginRight="5px" backgroundColor={newValue?.find(x => x.severityLevel === 1)?.color || "#D34D47"}></Box><Box> {formatMessage(messages.redIncidents)} (level 1):</Box></Box>
                                <AxionControls.AxionTextBox
                                    label={<FormattedMessage {...messages.name} />}
                                    value={newValue?.find(x => x.severityLevel === 1)?.name}
                                    autoComplete="new-password"
                                    inputProps={{ autoComplete: 'new-password' }}
                                    onChange={(event) =>
                                        handleValueChange(event, 1)
                                    }
                                /></Box>

                            <Box>
                                <Box sx={{ whiteSpace: 'nowrap' }} display="flex"><Box width="10px" height="10px" marginTop="4px" marginRight="5px" backgroundColor={newValue?.find(x => x.severityLevel === 2)?.color || "#ff9800"}></Box><Box> {formatMessage(messages.orangeIncidents)} (level 2):</Box></Box>
                                <AxionControls.AxionTextBox
                                    label={<FormattedMessage {...messages.name} />}
                                    value={newValue?.find(x => x.severityLevel === 2)?.name}
                                    autoComplete="new-password"
                                    inputProps={{ autoComplete: 'new-password' }}
                                    onChange={(event) =>
                                        handleValueChange(event, 2)
                                    }
                                /></Box>

                            <Box >
                                <Box sx={{ whiteSpace: 'nowrap' }} display="flex"><Box width="10px" height="10px" marginTop="4px" marginRight="5px" backgroundColor={newValue?.find(x => x.severityLevel === 3)?.color || "#F7E200"}></Box><Box> {formatMessage(messages.yellowIncidents)} (level 3):</Box></Box>
                                <AxionControls.AxionTextBox
                                    label={<FormattedMessage {...messages.name} />}
                                    value={newValue?.find(x => x.severityLevel === 3)?.name}
                                    autoComplete="new-password"
                                    inputProps={{ autoComplete: 'new-password' }}
                                    onChange={(event) =>
                                        handleValueChange(event, 3)
                                    }
                                /></Box>
                            <Box >
                                <Box sx={{ whiteSpace: 'nowrap' }} display="flex"><Box width="10px" height="10px" marginTop="4px" marginRight="5px" backgroundColor={newValue?.find(x => x.severityLevel === 4)?.color || "#43B328"}></Box><Box> {formatMessage(messages.greenIncidents)} (level 4):</Box></Box>
                                <AxionControls.AxionTextBox
                                    label={<FormattedMessage {...messages.name} />}
                                    value={newValue?.find(x => x.severityLevel === 4)?.name}
                                    autoComplete="new-password"
                                    inputProps={{ autoComplete: 'new-password' }}
                                    onChange={(event) =>
                                        handleValueChange(event, 4)
                                    }
                                /></Box>
                            <Box >
                                <Box sx={{ whiteSpace: 'nowrap' }} display="flex"><Box width="10px" height="10px" marginTop="4px" marginRight="5px" backgroundColor={newValue?.find(x => x.severityLevel === 5)?.color || "#6870fa"}></Box><Box> {formatMessage(messages.blueIncidents)} (level 5):</Box></Box>
                                <AxionControls.AxionTextBox
                                    label={<FormattedMessage {...messages.name} />}
                                    value={newValue?.find(x => x.severityLevel === 5)?.name}
                                    autoComplete="new-password"
                                    inputProps={{ autoComplete: 'new-password' }}
                                    onChange={(event) =>
                                        handleValueChange(event, 5)
                                    }
                                /></Box>


                        </Stack>

                        <Stack direction="row" width="100%" overflow="hidden" marginTop="15px" display="flex" justifyContent="flex-end">
                            <Controls.Button
                                text={<FormattedMessage {...messages.btn_close} />}
                                onClick={handleCloseValueDialog}
                                // startIcon={<SaveIcon />}
                                sx={{
                                    "&:hover": {
                                        backgroundColor: "#535560",
                                    },
                                    backgroundColor: colors.primary[300],
                                    color: "#000000",

                                }}
                            />
                            <Controls.Button
                                marginLeft="10px"
                                text={<FormattedMessage {...messages.save} />}
                                onClick={handleAddValue}
                                startIcon={<SaveIcon />}
                                sx={{
                                    "&:hover": {
                                        backgroundColor: colors.dashbordGreen[700],
                                    },
                                    backgroundColor: colors.dashbordGreen[500],
                                    color: "#000000",
                                    marginLeft: "10px"
                                }}
                            />
                        </Stack>
                    </DialogContent>
                </Box>
            </Dialog>

            <AxionConfirmation open={openConfirmationCategory} title={confirmationTitle} message={confirmationMessage} onConfirm={doDeleteCategory} onCancel={cancelDeleteCategory} cancelText={formatMessage(messages.no)} confirmText={formatMessage(messages.yes)} />
            {/* <AxionConfirmation open={openConfirmationValue} title={confirmationTitle} message={confirmationMessage} onConfirm={doDeleteDimensionValue} onCancel={cancelDeleteDimensionValue} cancelText={formatMessage(messages.no)} confirmText={formatMessage(messages.yes)} />  */}
        </>
    )
}